import React from "react";
import styled from "styled-components";
import { FiMail, FiPhone } from "react-icons/fi";

const Section = styled.section`
  background: linear-gradient(180deg, #fff8e1 0%, #ffce2d 100%);
  padding: 5rem 1.5rem;
`;

const Wrap = styled.div`
  max-width: 980px;
  margin: 0 auto;
  text-align: center;
`;

const Eyebrow = styled.p`
  text-transform: uppercase;
  letter-spacing: 0.18em;
  font-size: 0.85rem;
  color: #0a2a4a;
  font-weight: 700;
  margin-bottom: 0.5rem;
`;

const Heading = styled.h2`
  font-size: clamp(1.8rem, 4vw, 2.6rem);
  color: #0a2a4a;
  font-weight: 800;
  margin-bottom: 0.5rem;
`;

const Sub = styled.p`
  color: #0a2a4a;
  opacity: 0.85;
  margin-bottom: 2.5rem;
  font-weight: 500;
`;

const Cards = styled.div`
  display: grid;
  grid-template-columns: repeat(auto-fit, minmax(280px, 1fr));
  gap: 1.5rem;
`;

const Card = styled.div`
  background: #fff;
  border-radius: 20px;
  padding: 2rem 1.5rem;
  box-shadow: 0 18px 40px -20px rgba(10, 42, 74, 0.3);
  text-align: left;
  min-width: 0;
  max-width: 100%;
  overflow: hidden;
`;

const Name = styled.h3`
  color: #0a2a4a;
  font-size: 1.25rem;
  font-weight: 800;
  margin-bottom: 0.25rem;
  word-break: break-word;
`;

const Role = styled.p`
  color: #faa71e;
  font-weight: 700;
  font-size: 0.85rem;
  letter-spacing: 0.1em;
  text-transform: uppercase;
  margin-bottom: 1.25rem;
`;

const Row = styled.a`
  display: flex;
  align-items: center;
  gap: 0.75rem;
  color: #2d3e56;
  text-decoration: none;
  font-weight: 600;
  font-size: 0.95rem;
  padding: 0.5rem 0;
  transition: color 0.2s ease;
  min-width: 0;
  max-width: 100%;

  &:hover {
    color: #faa71e;
  }

  span {
    min-width: 0;
    flex: 1 1 auto;
    word-break: break-all;
    overflow-wrap: anywhere;
  }

  svg {
    color: #faa71e;
    flex-shrink: 0;
  }

  @media (max-width: 480px) {
    font-size: 0.85rem;
    gap: 0.5rem;
  }
`;

const contacts = [
  {
    name: "Armand Lesll",
    role: "Project Manager",
    email: "armand.lesll@rotaract.ro",
    phone: "0734 921 915",
  },
  {
    name: "Radu Bîrlan",
    role: "Fundraising",
    email: "radu.birlan@rotaract.ro",
    phone: "0755 135 500",
  },
  {
    name: "Bogdan Dobre",
    role: "Departament Tehnic",
    email: "bogdan.dobre@rotaract.ro",
    phone: "0728 143 986",
  },
];

const Contact = () => {
  return (
    <Section id="contact">
      <Wrap>
        <Eyebrow>Contact</Eyebrow>
        <Heading>Hai să facem împreună valuri de bine</Heading>
        <Sub>
          Ai o întrebare, vrei să te implici sau cauți un parteneriat? Suntem
          bucuroși să te auzim.
        </Sub>
        <Cards>
          {contacts.map((c) => (
            <Card key={c.email} data-aos="fade-up" data-aos-duration="600">
              <Name>{c.name}</Name>
              <Role>{c.role}</Role>
              <Row href={`mailto:${c.email}`}>
                <FiMail size={20} />
                <span>{c.email}</span>
              </Row>
              <Row href={`tel:${c.phone.replace(/\s/g, "")}`}>
                <FiPhone size={20} />
                <span>{c.phone}</span>
              </Row>
            </Card>
          ))}
        </Cards>
      </Wrap>
    </Section>
  );
};

export default Contact;
